import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Grid
} from "@mui/material";
import axios from "axios";

const BannerUpload = () => {
  const [form, setForm] = useState({ position: "", description: "" });
  const [file, setFile] = useState(null);
  const [banners, setBanners] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editingradial, seteditingradial] = useState(false);

  const token = localStorage.getItem("token");

  // Fetch banners on mount
  const fetchBanners = async () => {
    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/banner`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setBanners(res.data);
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  // Create or Update
  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("position", form.position);
    formData.append("description", form.description);
    if (file) formData.append("image", file);

    if (editingId) {
      // Update
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/banner/${editingId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      alert("Banner updated!");
    } else {
      // New upload
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/banner`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      alert("Banner uploaded!");
    }

    setForm({ position: "", description: ""});
    setFile(null);
    setEditingId(null);
    seteditingradial(false)
    fetchBanners();
  };

  const handleEdit = (banner) => {
    setForm({
      position: banner.position,
      description: banner.description,
    });
    setEditingId(banner.id);
    seteditingradial(banner.showRadialHub)
    setFile(null);
  };

  const handleDelete = async (id) => {
    await axios.delete(
      `${process.env.REACT_APP_API_BASE_URL}/api/api/banner/${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    fetchBanners();
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" mb={2}>
        {editingId ? "Edit Banner" : "Upload New Banner"}
      </Typography>
      <TextField
        label="Position"
        name="position"
        value={form.position}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Description"
        name="description"
        disabled={editingradial}
        value={form.description}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <input type="file" accept="image/*" onChange={(e) => setFile(e.target.files[0])} />
      <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
        <Button variant="contained" onClick={handleSubmit}>
          {editingId ? "Update" : "Upload"}
        </Button>
        {editingId && (
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => {
              setEditingId(null);
              setForm({ position: "", description: ""});
              setFile(null);
            }}
          >
            Cancel
          </Button>
        )}
      </Box>

      {/* List of Banners */}
      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          Existing Banners
        </Typography>
        <Grid container spacing={2}>
          {banners.map((banner) => (
            <Grid item xs={12} md={4} key={banner.id}>
              <Card>
                {banner.image && (
                  <CardMedia
                    component="img"
                    height="140"
                    image={banner.image}
                    alt="banner"
                  />
                )}
                <CardContent>
                  <Typography variant="body1">
                    <b>Position:</b> {banner.position}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    {banner.description}
                  </Typography>
                  <Typography variant="caption">
                    Radial Hub: {banner.showRadialHub ? "Yes" : "No"}
                  </Typography>
                  <Box sx={{ mt: 2, display: "flex", gap: 1 }}>
                    <Button size="small" variant="outlined" onClick={() => handleEdit(banner)}>
                      Edit
                    </Button>
                    <Button
                      size="small"
                      variant="contained"
                      color="error"
                      onClick={() => handleDelete(banner.id)}
                    >
                      Delete
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default BannerUpload;
